import bowser from 'bowser';
import { EXTENSION } from '@/constants';

const {
  parsedResult: {
    browser: { name, version },
    platform: { type },
  },
} = bowser.getParser(window.navigator.userAgent);

export const getBrowserName = () => name;

export const getBrowserVersion = () => version;

export const getPlatform = () => type;

export const isDesktop = () => getPlatform() === 'desktop';

export const getBrowserData = () => ({
  browser: getBrowserName(),
  version: getBrowserVersion(),
  platform: getPlatform(),
});

export const getBrowserKey = () => getBrowserName().toUpperCase().replace(' ', '_');

export const isSupportedBrowser = () => Boolean(EXTENSION[getBrowserKey()]) && isDesktop();
